import {
    ActivityEntityName,
    ActivityTypeName,
} from '../../services/apollo/inopack-graphql-schema';

// Single source of truth for how an activity is labeled in Spanish. Reused by
// the activities page (table columns) and the live snackbar so they never drift.

export function getActivityEntityLabel(
    entityName: ActivityEntityName,
): string {
    switch (entityName) {
        case ActivityEntityName.OrderProduction:
            return 'Orden de producción';
        case ActivityEntityName.OrderSale:
            return 'Venta';
        case ActivityEntityName.OrderRequest:
            return 'Pedido';
        case ActivityEntityName.Product:
            return 'Producto';
        case ActivityEntityName.Employee:
            return 'Empleado';
        case ActivityEntityName.OrderAdjustment:
            return 'Ajuste';
        // NOT 'Cliente': the same table holds suppliers and own accounts, so
        // the specific word would be wrong more often than it is right.
        case ActivityEntityName.Account:
            return 'Cuenta';
        case ActivityEntityName.Machine:
            return 'Maquina';
        case ActivityEntityName.User:
            return 'Usuario';
        case ActivityEntityName.Transfer:
            return 'Transferencia';
        case ActivityEntityName.Resource:
            return 'Recurso';
        case ActivityEntityName.Expense:
            return 'Gasto';
        // Expense resources are child rows of a Gasto, not a top-level
        // activity entity. Leaving this enum value unlabeled keeps the dead
        // legacy value out of the entity filter.
        case ActivityEntityName.ProductionPlan:
            return 'Planeación';
        default:
            return '';
    }
}

export function getActivityTypeLabel(type: ActivityTypeName): string {
    switch (type) {
        case ActivityTypeName.Create:
            return 'Creación';
        case ActivityTypeName.Update:
            return 'Actualización';
        case ActivityTypeName.Delete:
            return 'Eliminación';
        default:
            return '';
    }
}

// Short message for the live snackbar, e.g. "Venta 1042 (F103) · ACME ·
// Actualización".
//
// The activities page renders the entity in its own column, so the stored
// `title` carries no entity word. A snackbar has no columns, so it puts one
// back here — this is the only place that composes the three parts.
export function formatActivityMessage(activity: {
    type: ActivityTypeName;
    entity_name: ActivityEntityName;
    title: string;
}): string {
    const entityLabel = getActivityEntityLabel(activity.entity_name);
    const typeLabel = getActivityTypeLabel(activity.type);

    return `${entityLabel} ${activity.title} · ${typeLabel}`.trim();
}
